<script>
    export default {
        name: "ProductDiscount",
        props: {
            percent: Number,
        },
    };
</script>

<template>
    <div class="product-discount">–{{ percent }}%</div>
</template>

<style lang="scss">
    .product-discount {
        padding: 7px 8px 8px;
        color: #fff;
        font-family: var(--secondary-font);
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;
        text-align: center;
        border-radius: 25px;
        background-color: #b342ff;
        @include bp($bp-desktop-sm) {
            padding: 9px 11px 10px;
            font-size: 20px;
            line-height: 20px;
        }
    }
</style>
